// ============================================================================
// FSA TEMPLATE ENDPOINTS
// ============================================================================
// URL builders for the FSA Template browser (Stage 1 = read-only).
// Backend controller: FsaTemplatesController → /api/v1/FsaTemplates
//
// Per prima-web/CLAUDE.md Module Boundaries: FSA endpoints live under
// api/endpoints/fsa/ — never alongside basic-tier endpoints.

import { buildEndpoint, buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaTemplates';

export const fsaTemplateEndpoints = {
  /** GET /api/v1/FsaTemplates — paged list of template headers */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/FsaTemplates/{id} — single header (no children) */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/FsaTemplates/{id}/full — full template hierarchy */
  getFullHierarchy: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/full`, { id }),

  /**
   * GET /api/v1/FsaTemplates/{id}/preview-pdf — server-rendered PDF binary
   * for the View Modal's Preview & Print action. Response is the PDF blob
   * (Content-Type: application/pdf).
   */
  getPreviewPdf: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/preview-pdf`, { id }),

  /** Raw path for buildEndpointWithQuery (carries no version prefix) */
  basePath: () => BASE_PATH,
} as const;

export default fsaTemplateEndpoints;
